import Layer from '@arcgis/core/layers/Layer';

/**
 * Create and return a new layer instance from a service url.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-Layer.html#fromArcGISServerUrl
 * @param {String} url - GIS supplemental service url
 */
export const createLayerFromUrl = async ({ url, ...props }) => {
  const { apiKey } = props;

  const requestUrl = apiKey ? (url += `?token=${apiKey}`) : url;

  const layer = await Layer.fromArcGISServerUrl({
    url: requestUrl,
    properties: {
      ...(props && { ...props }),
    },
  });

  // Layer must be loaded so that properties such as `sublayers` can be queried.
  await layer.load();

  return layer;
};
